'use client';

import type { AnswerValue } from '@repo/contracts/cardfinder/funnel/types';
import { useContext } from 'react';
import { AnswerStoreContext } from './answer-store-context';
import type { UseAnswerResult } from './types';

function useAnswerStoreContext() {
  const ctx = useContext(AnswerStoreContext);
  if (!ctx) throw new Error('useAnswer must be used within FunnelSessionProvider');
  return ctx;
}

export function useAnswer<T extends AnswerValue>(stepId: string): UseAnswerResult<T> {
  const { store, setAnswer, clearAnswer } = useAnswerStoreContext();
  return {
    value: store.answers[stepId] as T | undefined,
    setAnswer: (next: T) => setAnswer(stepId, next),
    clear: () => clearAnswer(stepId),
  };
}

export function useIsAnswerHydrated() {
  return useAnswerStoreContext().store.isHydrated;
}

export function useSubmittedAnswers() {
  return useAnswerStoreContext().store.submittedAnswers;
}

export function useShouldSkipRecommendations() {
  return useAnswerStoreContext().store.shouldSkipRecommendations;
}
